import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Chip, Checkbox, Stack, FormControlLabel, FormGroup, TextField, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { Cancel, MoreVert, FormatListBulleted, Task, Check } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SaveButton from '../Components/SaveButton';
import { isEmpty } from 'lodash';
import DeleteIcon from '@mui/icons-material/Delete';
import LinkCode from '../Modals/LinkCode';
import LinkForm from '../Modals/LinkForm';
import axios from 'axios';
import { APIURL, CERBOSURL } from '../../../config';
import Permissions from '../Modals/Permissions';
import entities from '../../../resources.json';
import { CircularProgress } from '@mui/material';

const EmpType = (props) => {
    const [empTypeList, setEmpTypeList] = useState([]);
    const [selectedEmpTypes, setSelectedEmpTypes] = useState([]);
    const [originalEmpTypes, setOriginalEmpTypes] = useState([]);
    const [empType, setEmpType] = useState("");
    const [empTypeError, setEmpTypeError] = useState('');
    const [currentEmpType, setCurrentEmpType] = useState({});
    const [taskTypeEditMode, setTaskTypeEditMode] = useState(false);
    const [permissionsEditMode, setPermissionsEditMode] = useState(false);
    const [newPayerDets, setNewPayerDets] = useState(props.payerList);
    const [openPermissions, setOpenPermissions] = useState(false);
    const [currentEmpTypePermissions, setCurrentEmpTypePermissions] = useState({});
    const [newEmpTypeMode, setNewEmpTypeMode] = useState(false);
    const [refPermissions, setRefPermissions] = useState(props.user.permissions);
    const [saving, setSaving] = useState(false);
    const [statusMessage, setStatusMessage] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClosePermissions = () => {
        setNewEmpTypeMode(false);
        setEmpType("");
        setRefPermissions(props.user.permissions);
        setCurrentEmpTypePermissions({});
        setOpenPermissions(false);
    }

    const handleEditPermissions = (empType) => {
        setPermissionsEditMode(true);
        console.log(empType);
        let parent = originalEmpTypes.find((ele) => String(ele.title).toLowerCase() === (String(empType.employeeType).toLowerCase() === 'all' ? 'admin' : String(empType.employeeType).toLowerCase()));
        console.log(parent);
        setRefPermissions(parent.permissions);
        setOpenPermissions(true);
    }

    const handleViewPermissions = (empType) => {
        setPermissionsEditMode(false);
        let parent = originalEmpTypes.find((ele) => String(ele.title).toLowerCase() === (String(empType.employeeType).toLowerCase() === 'all' ? 'admin' : String(empType.employeeType).toLowerCase()));
        setRefPermissions(parent.permissions);
        setOpenPermissions(true);
    }

    const handleUpdatePermissions = (perm, value) => {
        if (newEmpTypeMode || permissionsEditMode) {
            setCurrentEmpType({
                ...currentEmpType,
                permissions: {
                    ...currentEmpType.permissions,
                    [perm]: value,
                }
            })
        }
    }

    const handleNewEmpTypeUpdate = (val) => {
        console.log(val);
        if (val === 'manager') {
            setCurrentEmpType({...currentEmpType, parent_role: "admin", employeeType: "admin", permissions: empTypeList.find((type) => String(type.title).toLowerCase() === "manager").permissions});
            console.log(empTypeList.find((type) => String(type.title).toLowerCase() === "admin"))
            setRefPermissions(empTypeList.find((type) => String(type.title).toLowerCase() === "admin").permissions)
        } else {
            setCurrentEmpType({...currentEmpType, parent_role: "manager", employeeType: "manager", permissions: empTypeList.find((type) => String(type.title).toLowerCase() === "fieldworker").permissions});
            console.log(empTypeList.find((type) => String(type.title).toLowerCase() === "manager"))
            setRefPermissions(empTypeList.find((type) => String(type.title).toLowerCase() === "manager").permissions)
        }
    }

    const handleSavePermissions = () => {
        if (newEmpTypeMode) {
            setEmpTypeList([...empTypeList,currentEmpType])
        } else {

            setEmpTypeList(empTypeList.map((empType) => {
                if (empType.id === currentEmpType.id) {
                    return currentEmpType;
                }
                return empType;
            }))
        }
        handleClosePermissions();
    }

    const textFieldRef = useRef(null);

    useEffect(() => {
        if (taskTypeEditMode) {
            textFieldRef.current?.focus();
        }
    }, [taskTypeEditMode]);

    let resources = entities.resources;
    let predefinedRoles = ['fieldworker', 'supportcoordinator', 'manager', 'admin', 'casemanager'];

    useEffect(() => {
        async function fetchData() {

            const updatedEmpTypeList = await Promise.all(
                props.empTypeList.filter((ele) => ele.is_Active !== 2).map(async (type) => {

                    const features = {};
                    const batchSize = 50;

                    const roleName = predefinedRoles.includes(String(type.EntityValue).replaceAll(" ", "").toLowerCase()) 
                        ? String(type.EntityValue).replaceAll(" ", "").toLowerCase()
                        : `${String(type.EntityValue).replaceAll(" ", "").toLowerCase()}_${props.user.comp_id}`;

                    for (let index = 0; index < resources.length; index += batchSize) {
                        const currentBatch = resources.slice(index, Math.min(index + batchSize, resources.length));

                        console.log(roleName);

                        const checkAccess = await axios.post(CERBOSURL + "/check/resources", {
                            principal: {
                                id: String(props.user.emp_id),
                                roles: [roleName],
                                attr: {
                                    states: props.user.states.map((s) => s.state_id),
                                    modules: props.user.comp_settings.map((f) => f.feature_id),
                                    company_type: props.user.comp_settings.find((s) => s.feature_value === 'primaryBusinessType').feature_id,
                                }
                            },
                            resources: currentBatch.map((r) => ({
                                resource: {
                                    ...r.resource,
                                    id: r.resource.id + String(props.user.emp_id),
                                },
                                actions: r.actions,
                            }))
                        });
                        currentBatch.forEach((resource) => {
                            const resourceId = resource.resource.id + String(props.user.emp_id);
                            const result = checkAccess.data.results.find((ele) => ele.resource.id === resourceId);
                            features[String(resource.resource.id).split("#")[0]] = result.actions[resource.actions[0]] === 'EFFECT_ALLOW';
                            // features[`${String(resource.resource.id).split("#")[0]}_${String(resource.resource.kind)}_${String(resource.actions[0])}`] = result.actions[resource.actions[0]] === 'EFFECT_ALLOW';
                        });
                    }
                    return { ...type, permissions: features };
                })
            );


            setEmpTypeList(updatedEmpTypeList.map((type) => {
                return { title: type.EntityValue, id: type.ddID, deletable: type.is_Active === 3 || type.is_Active === 4, is_Active: type.is_Active, employeeType: type.employeeType, permissions: type.permissions }
            }));
            setSelectedEmpTypes(updatedEmpTypeList.filter((type) => type.is_Active === 0 || type.is_Active === 3).map((type) => {
                return { title: type.EntityValue, id: type.ddID, deletable: type.is_Active === 3 || type.is_Active === 4, is_Active: type.is_Active, employeeType: type.employeeType, permissions: type.permissions }
            }));
            setOriginalEmpTypes(updatedEmpTypeList.map((type) => {
                return { title: type.EntityValue, id: type.ddID, deletable: type.is_Active === 3 || type.is_Active === 4, is_Active: type.is_Active, employeeType: type.employeeType, permissions: type.permissions }
            }));

            let newPayerDetails = await axios.get(APIURL + `/associate_payer`, {
                params: {
                    compId: props.comp_id,
                }
            });

            setNewPayerDets(newPayerDets.filter((p) => newPayerDetails.data.map((p) => p.payerId).includes(p.payer_id)));

        }

        fetchData();
    }, [props.empTypeList]);


    const handleEmpTypeChange = (event) => {
        const value = event.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setEmpType(value);
        }
        else {
            setEmpTypeError('Only alphabets and spaces are allowed');
        }
    }

    const handleAddNewEmpType = () => {
        if (isEmpty(empType)) return;
        setNewEmpTypeMode(true);
        setCurrentEmpType({
            id: Math.max(...empTypeList.map((empType) => empType.id)) + 1,
            title: empType,
            is_Active: 3,
            deletable: true,
            permissions: props.user.permissions,
        });
        setPermissionsEditMode(true);
        setOpenPermissions(true);
    }

    const handleChipDelete = (type) => {
        setEmpTypeList(empTypeList.map((et) => {
            if (et.id === type.id) {
                return {
                    ...et,
                    is_Active: et.is_Active == 0 ? 1 : 4,
                };
            }
            return {...et};
        }))
        setSelectedEmpTypes(selectedEmpTypes.filter((t) => t.id !== type.id));
    }

    const handleCheckBoxChange = (event) => {
        if(event.target.checked) {
            let type = empTypeList.find((type) => type.title === event.target.name);
            setEmpTypeList(empTypeList.map((et) => {
                if (et.title === event.target.name) {
                    return {
                        ...et,
                        is_Active: et.is_Active == 1 ? 0 : 3,
                    };
                }
                return {...et};
            }));
            setSelectedEmpTypes([...selectedEmpTypes, { title: event.target.name, id: type.id, deletable: type.deletable }]);
        } else {
            setEmpTypeList(empTypeList.map((et) => {
                if (et.title === event.target.name) {
                    return {
                        ...et,
                        is_Active: et.is_Active == 0 ? 1 : 4,
                    };
                }
                return {...et};
            }));
            setSelectedEmpTypes(selectedEmpTypes.filter((type) => type.title !== event.target.name));
        }
    }

    const handleSave = async () => {

        setSaving(true);
        setStatusMessage(null);

        let newEmpTypeIdMap = {};

        const originalIds = new Set(originalEmpTypes.map(et => et.id));
        const added = empTypeList.filter(ele => !originalIds.has(ele.id));

        const updated = empTypeList.filter(et => {
            const original = originalEmpTypes.find(oe => oe.id === et.id);
            return original && JSON.stringify(et) !== JSON.stringify(original);
        });

        const deleted = originalEmpTypes.filter(oe => !empTypeList.find(et => et.id === oe.id));

        let success = [], failed = [];
        console.log(added, updated, deleted);

        try {

            for (const empType of added) {
                let updatedPermissions = {}
                Object.entries(empType.permissions).forEach(([perm, val]) => {
                    let fullResource = resources.find(res => res.resource.id.split("#")[0] === perm);
                    let key = `${perm}_${fullResource.resource.kind}_${fullResource.actions[0]}`;
                    updatedPermissions[key] = val;
                })
                let addResp = await axios.post(APIURL + "/dropdowns/", {
                        entityValue: empType.title,
                        emp_id: props.user.emp_id,
                        comp_id: props.user.comp_id,
                        entityName: "empType",
                        is_Active: empType.is_Active,
                        permissions: updatedPermissions,
                        parent_role: empType.parent_role,
                });
                if (!addResp.data.status.success) {
                    failed.push({role: empType.title, operation: 'add'});
                } else {
                    success.push({role: empType.title, operation: 'add'});
                }
                newEmpTypeIdMap[empType.id] = addResp.data.dd_data.id;
            }

            for (const empType of updated) {
                let updatedPermissions = {}
                Object.entries(empType.permissions).forEach(([perm, val]) => {
                    let fullResource = resources.find(res => res.resource.id.split("#")[0] === perm);
                    let key = `${perm}_${fullResource.resource.kind}_${fullResource.actions[0]}`;
                    updatedPermissions[key] = val;
                })
                let updateResp = await axios.put(APIURL + "/dropdowns/", {
                        ddId: empType.id,    
                        entityValue: empType.title,
                        emp_id: props.user.emp_id,
                        comp_id: props.user.comp_id,
                        entityName: "empType",
                        is_Active: empType.is_Active,
                        permissions: updatedPermissions,
                        parent_role: empType.employeeType,
                        updatePermissions: JSON.stringify(empType.permissions) !== JSON.stringify(originalEmpTypes.find(oe => oe.id === empType.id).permissions),
                });
                console.log(updateResp)
                if (!updateResp.data.status.success) {
                    failed.push({role: empType.title, operation: 'update'});
                } else {
                    success.push({role: empType.title, operation: 'update'});
                }
            }

            for (const empType of deleted) {
                let deleteResp = await axios.delete(APIURL + "/dropdowns/", {
                    data: {
                        entityValue: empType.title,
                        id: empType.id,
                        emp_id: props.user.emp_id,
                        comp_id: props.user.comp_id,
                        entityName: "empType",
                    }
                });
                console.log(deleteResp);
                if (!deleteResp.data.status.success) {
                    failed.push({role: empType.title, operation: 'delete', id: empType.id});
                } else {
                    success.push({role: empType.title, operation: 'delete', id: empType.id});
                }
            }

            console.log("EmpTypes sync complete.");
            console.log(success, failed);
            setEmpTypeList(empTypeList.map((empType) => {
                if (newEmpTypeIdMap[empType.id] !== undefined) {
                    return {
                        ...empType,
                        id: newEmpTypeIdMap[empType.id],
                    }
                }
                return empType;
            }));
            setOriginalEmpTypes(empTypeList.map((empType) => {
                if (newEmpTypeIdMap[empType.id] !== undefined) {
                    return {
                        ...empType,
                        id: newEmpTypeIdMap[empType.id],
                    }
                }
                return empType;
            }));
            setStatusMessage({ type: 'success', text: 'Saved successfully! Changes may take a couple of mins to reflect.' });
        } catch (error) {
            setEmpTypeList(originalEmpTypes);
            console.error("Failed to sync empTypes:", error);
            setStatusMessage({ type: 'error', text: 'Failed to save changes.' });
        }finally {
            setSaving(false);
            setTimeout(() => setStatusMessage(null), 8000); // auto-dismiss after 5s
        }

    }

    const handleDelete = async (empType) => {
        setEmpTypeList(empTypeList.filter((ele) => ele.id !== empType.id));
        setSelectedEmpTypes(empTypeList.filter((ele) => ele.id !== empType.id));
    }


    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid size={props.leftColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h5">
                            Employee Types
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'gray' }}>
                            Which Employee types do you have?
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={props.rightColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Types
                        </Typography>
                        <Box sx={{ minHeight: 32 }}>
                            <Box sx={{ minHeight: 40 }}>
                                {selectedEmpTypes.length === 0 && <Typography variant="body1" sx={{ color: 'gray' }}>No Types selected</Typography>}
                                {selectedEmpTypes.map((empType, index) => {
                                    return (
                                        <Chip key={index} label={empType.title} onDelete={() => handleChipDelete(empType)} sx={{ mr: 1, mb: 1 }} color="primary" />
                                    );
                                })}
                            </Box>
                            <Typography variant="h6">
                                Select Types
                            </Typography>
                        </Box>
                        <FormGroup>
                            <Grid container spacing={0}>
                                {empTypeList.map((empType, index) => (
                                    <Grid size={6} key={index}>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                            {
                                                <FormControlLabel
                                                    sx={{ height: 25, alignSelf: 'center' }}
                                                    control={<Checkbox checked={selectedEmpTypes.find((t) => t.id === empType.id) ? true : false} onChange={handleCheckBoxChange} name={empType.title} sx={{ margin: 0 }} id={empType.id} />}
                                                    label={empType.title}
                                                />
                                            }
                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'nowrap' }}>
                                                {!(empType.is_Active === 3 || empType.is_Active === 4) ?
                                                    <IconButton size='small' sx={{ bottom: 6 }} onClick={(event) => { setCurrentEmpType(empType); handleViewPermissions(empType); handleClose(); }}>
                                                        <VisibilityIcon fontSize='small' />
                                                    </IconButton> : <IconButton size='small' sx={{ bottom: 6 }} onClick={(event) => { setCurrentEmpType(empType); handleEditPermissions(empType); handleClose(); }}>
                                                        <EditIcon fontSize='small' />
                                                    </IconButton>
                                                }
                                                {empType.deletable && 
                                                    <IconButton size='small' sx={{ bottom: 6 }} onClick={(event) => handleDelete(empType)}>
                                                        <DeleteIcon fontSize='small' />
                                                    </IconButton>
                                                }
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </FormGroup>
                        {!props.disableAddNew &&
                            <Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Box sx={{ width: '100%' }}>
                                        <TextField
                                            variant="outlined"
                                            label="Add New Types"
                                            size="small"
                                            value={empType}
                                            onChange={handleEmpTypeChange}
                                            fullWidth
                                            error={Boolean(empTypeError)}
                                            helperText={empTypeError}
                                        />
                                    </Box>
                                    <Button variant="contained" sx={{ ml: 2, width: 100, height: 40 }} color="primary" onClick={handleAddNewEmpType} disabled={!empType || originalEmpTypes.some(employeeType => String(employeeType.title).toLowerCase().replaceAll(" ","") === String(empType).toLowerCase().replaceAll(" ",""))}>Add</Button>
                                </Box>
                                {originalEmpTypes.some(empType => String(empType.title).toLowerCase().replaceAll(" ","") === String(empType).toLowerCase().replaceAll(" ","")) && <Typography variant="body2" color="error" sx={{ mt: 1 }}>Emp Type already exists</Typography>}
                            </Box>
                        }
                        {saving && (
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                                <CircularProgress size={20} sx={{ mr: 1 }} />
                                <Typography variant="body2">Saving...</Typography>
                            </Box>
                        )}

                        {statusMessage && (
                            <Typography
                                variant="body2"
                                sx={{
                                mt: 2,
                                color: statusMessage.type === 'success' ? 'green' : 'red',
                                fontWeight: 500,
                                }}
                            >
                                {statusMessage.text}
                            </Typography>
                        )}
                        <SaveButton onClick={() => handleSave()} disabled={JSON.stringify(empTypeList) === JSON.stringify(originalEmpTypes)}/>
                        {<Permissions open={openPermissions} onClose={handleClosePermissions} onSave={handleSavePermissions} editMode={permissionsEditMode} addNew={newEmpTypeMode} empType={currentEmpType} handleNewEmpTypeUpdate={handleNewEmpTypeUpdate} refPermissions={refPermissions} user={props.user} handleUpdatePermissions={handleUpdatePermissions} />}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}

export default EmpType;
